import { apiClient } from './client';

export const listSharedConfigs = () =>
  apiClient.get('/dashboard/shared-configs').then((r) => r.data.configs);

export const getSharedConfig = (id) =>
  apiClient.get(`/dashboard/shared-configs/${id}`).then((r) => r.data);

export const saveSharedConfig = ({ name, description, config }) =>
  apiClient.post('/dashboard/shared-configs', { name, description, config }).then((r) => r.data);

export const updateSharedConfig = (id, { name, description, config }) =>
  apiClient.put(`/dashboard/shared-configs/${id}`, { name, description, config }).then((r) => r.data);

export const deleteSharedConfig = (id) =>
  apiClient.delete(`/dashboard/shared-configs/${id}`);
